var service = 'time';

angular.module('eficienciaFiscalModule')
    .service(service + 'Service', ['$timeout', 'httpService', 'pathService',
        function ($timeout, httpService, pathService) {

            var route = pathService.getApiUrl() + '/base/time/',
                screenId = "#base";

            this.getList = function (callback, event, loadText, blockScreen) {
                return httpService.request({
                    url: route,
                    method: "GET",
                    blockScreen: blockScreen != undefined ? blockScreen : true,
                    screenId: screenId,
                    clickEvent: event,
                    loadingText: loadText,
                    onSuccess: function (data) {
                        if (callback)
                            if (data.data)
                                callback(data.data);
                    }
                })
            };

            this.get = function (params, callback, event, loadText, blockScreen) {
                var url = route + '?';
                for (var key in params)
                    if (params.hasOwnProperty(key) && params[key] != undefined && (params[key].length == undefined || params[key].length > 0))
                        url += key + '=' + params[key] + '&';
                return httpService.request({
                    url: url,
                    method: "GET",
                    blockScreen: blockScreen != undefined ? blockScreen : true,
                    screenId: screenId,
                    clickEvent: event,
                    loadingText: loadText,
                    onSuccess: function (data) {
                        if (callback)
                            if (data.data)
                                callback(data.data);
                    }
                })
            }
        }
    ]);
